import { Reveal } from "../Reveal";
import { ASSETS } from "../../lib/site";

const CHAPTERS = [
  {
    num: "01",
    title: "Materials First",
    body: "Superiority begins at the molecular level. Our nTHERM composite platform reduces mass while multiplying thermal and ballistic resistance — the foundation beneath every product we ship.",
  },
  {
    num: "02",
    title: "Precision As Doctrine",
    body: "Tolerances measured in microns. Every projectile, every plate, every seat is engineered to perform identically under conditions where failure is not an option.",
  },
  {
    num: "03",
    title: "Dedicated To The Operator",
    body: "We build for the people downrange. Our mission is protection and capability for those who defend — distributed through focused, best-in-class product brands.",
  },
];

export const Manifesto = () => {
  return (
    <section data-testid="manifesto-section" className="relative bg-surface py-24 md:py-32 lg:py-40 overflow-hidden">
      <img
        src={ASSETS.manifestoBg}
        alt=""
        aria-hidden="true"
        className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-[0.12] hidden lg:block"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-surface via-surface to-transparent" />

      <div className="container-x relative z-10">
        <Reveal className="max-w-2xl mb-20">
          <p className="overline mb-5">Our Manifesto</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-textmain leading-[0.95]">
            The principles that<br />drive the mission
          </h2>
        </Reveal>

        <div className="space-y-px">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.1}>
              <div className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start py-12 border-t border-white/10">
                <div className="md:col-span-3">
                  <span className="font-heading text-6xl md:text-7xl font-bold text-white/10 group-hover:text-steel/60 transition-colors duration-500 leading-none">
                    {c.num}
                  </span>
                </div>
                <div className="md:col-span-9 grid grid-cols-1 md:grid-cols-3 gap-6">
                  <h3 className="md:col-span-1 font-heading text-2xl md:text-3xl font-semibold uppercase tracking-tight text-textmain">
                    {c.title}
                  </h3>
                  <p className="md:col-span-2 text-textmuted text-base md:text-lg leading-relaxed">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
